import "./module/userAgentChecker.js";
import "./module/responsive.js";
import "./module/modal.js";
import "./module/header2.js";

import Swiper from "swiper/bundle";
var myswiper = new Swiper(".fade-slider", {
    centeredSlides: true,
    effect: "fade",
    loop: true,
    speed: 2500,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    simulateTouch: false,
    allowSwipeToPrev: false,
    allowSwipeToNext: false,
});

var myswiper02 = new Swiper(".news-slider", {
    slidesPerView: 4,
    spaceBetween: 28,
    breakpoints: {
        414: {
            slidesPerView: "auto",
            //centeredSlides: true,
            spaceBetween: 25,
        },
    },
});

var myswiper03 = new Swiper(".bnr-slider", {
    slidesPerView: "auto",
    spaceBetween: 28,
    centeredSlides: true,
    loop: true,
    speed: 2500,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        414: {
            spaceBetween: 40,
        },
    },
});

var myswiper04 = new Swiper(".sliderDown01", {
    direction: "vertical",
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,
    speed: 4500,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    simulateTouch: false,
});

var myswiper05 = new Swiper(".sliderDown02", {
    direction: "vertical",
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,
    speed: 4500,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    simulateTouch: false,
});

var myswiper06 = new Swiper(".sliderUp", {
    direction: "vertical",
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    speed: 4500,
    autoplay: {
        reverseDirection: true,
        delay: 0,
        disableOnInteraction: false,
    },
    simulateTouch: false,
});

var myswiper07 = new Swiper(".interviewSlider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 450,
    simulateTouch: false,
    breakpoints: {
        1025: {
            slidesPerColumnFill: "row",
            spaceBetween: 60,
            slidesPerView: 3,
            slidesPerColumn: 2,
            slidesPerGroup: 6,
        },
    },
});

var myswiper08 = new Swiper(".requireSlider-career", {
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 450,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1025: {
            spaceBetween: 50,
        },
    },
});

var myswiper09 = new Swiper(".requireSlider-graduate", {
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 450,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1025: {
            spaceBetween: 50,
        },
    },
});

var myswiper10 = new Swiper(".pokapoka-slider", {
    slidesPerView: "auto",
    loop: true,
    speed: 4500,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
    },
    simulateTouch: false,
    allowSwipeToPrev: false,
    allowSwipeToNext: false,
});

var $ = require("jquery");
const mediaQuery = window.matchMedia("(max-width: 1024px)");

// ページが読み込まれた時に実行
handle(mediaQuery);

// ウィンドウサイズを変更しても実行（ブレイクポイントの監視）
mediaQuery.addListener(handle);

function handle(mm) {
    if (mm.matches) {
        $(".header__innerNavListSingle > div").on("click", function () {
            //クリックされた.accordion_oneの中の.accordion_headerに隣接する.accordion_innerが開いたり閉じたりする。
            $(this).next("ul").slideToggle();
            $(this).toggleClass("is-open");
        });
    }
}

import ScrollMagic from "scrollmagic";
class ScrollFade {
    constructor() {
        this.ANIMATION_CLASS = "is-animation";

        let $section = document.querySelectorAll(".scroll:not(.is-animation)");
        if ($section.length === null) {
            return;
        }
        let controller = new ScrollMagic.Controller();
        for (let i = 0; i < $section.length; i++) {
            let scene = new ScrollMagic.Scene({
                triggerElement: $section[i],
                triggerHook: "onEnter",
                reverse: false,
                offset: 150,
            }).addTo(controller);
            scene.on("enter", () => {
                $section[i].classList.add(this.ANIMATION_CLASS);
            });
            scene.on("end", () => {
                scene.destroy(true);
            });
        }
    }
}

new ScrollFade();

import objectFitImages from "object-fit-images";
objectFitImages();

import ModalVideo from "modal-video";
new ModalVideo(".modalBtn", {
    youtube: {
        autoplay: 1,
        mute: 1,
        loop: 1,
        showinfo: 0,
    },
});

import Rellax from "rellax";
var rellax = new Rellax(".parallax", {
    speed: 1,
    center: true,
});
